export const bloodBankMenuDef = [
    {
        "name": "menu.bloodBank",
        "resource": "emr_format",
        "icon": "fa fa-user-md",
        "url": "emr_format",
        "auto_crud": true,
        "breadcrumb": "Blood Bank",
        "check_permission": false,
        "showMenu": false
    },
    // {
    //     "name": "menu.blood_component",
    //     "resource": "blood_component",
    //     "icon": "fa fa-file-text-o",
    //     "url": "blood_component",
    //     "auto_crud": true,
    //     "permission_required": false,
    //     "breadcrumb": "Blood Component",
    //     "check_permission": false
    // },
    {
        "name": "menu.bb_component_new_sepration",
        "resource": "bb_component_new_sepration",
        "icon": "fa fa-file-text-o",
        "url": "bb_component_new_sepration",
        "auto_crud": true,
        "permission_required": true,
        "breadcrumb": "Component Separation",
        "check_permission": false
    },
    {
        "name": "menu.component_separation",
        "resource": "bb_component_separation",
        "icon": "fa fa-file-text-o",
        "url": "bb_component_separation",
        "auto_crud": true,
        "permission_required": true,
        "breadcrumb": "Component Separation",
        "check_permission": false
    },
    {
        "name": "menu.bb_camp_master",
        "resource": "bb_camp_master",
        "icon": "fa fa-file-text-o",
        "url": "bb_camp_master",
        "auto_crud": true,
        "permission_required": true,
        "breadcrumb": "Blood Compatibility Master",
        "check_permission": false
    },
    {
        "name": "menu.bb_component_definition",
        "resource": "bb_component_definition",
        "icon": "fa fa-file-text-o",
        "url": "bb_component_definition",
        "auto_crud": true,
        "permission_required": true,
        "breadcrumb": "Blood Component Definition",
        "check_permission": false
    },
    {
        "name": "menu.bb_bag_type",
        "resource": "bb_bag_type",
        "icon": "fa fa-file-text-o",
        "url": "bb_bag_type",
        "auto_crud": true,
        "permission_required": true,
        "breadcrumb": "Blood Bag Type",
        "check_permission": false
    },
    {
        "name": "menu.bb_bag_component_mapping",
        "resource": "bb_bag_component_mapping",
        "icon": "fa fa-file-text-o",
        "url": "bb_bag_component_mapping",
        "auto_crud": true,
        "permission_required": true,
        "breadcrumb": "Bag Component Mapping",
        "check_permission": false
    },
    {
        "name": "menu.bb_blood_compatability",
        "resource": "bb_blood_compatability",
        "icon": "fa fa-file-text-o",
        "url": "bb_blood_compatability",
        "auto_crud": true,
        "permission_required": true,
        "breadcrumb": "Blood Compatibility Master",
        "check_permission": false
    },
    {
        "name": "menu.bb_donation_time",
        "resource": "bb_donation_time",
        "icon": "fa fa-file-text-o",
        "url": "bb_donation_time",
        "auto_crud": true,
        "permission_required": true,
        "breadcrumb": "Blood Donation Time",
        "check_permission": false
    },
    {
        "name": "menu.bb_order_type",
        "resource": "bb_order_type",
        "icon": "fa fa-file-text-o",
        "url": "bb_order_type",
        "auto_crud": true,
        "permission_required": true,
        "breadcrumb": "Blood Bank Order Type Master",
        "check_permission": false
    },
    {
        "name": "menu.bb_alternate_blood_group_master",
        "resource": "bb_alternate_blood_group_master",
        "icon": "fa fa-file-text-o",
        "url": "bb_alternate_blood_group_master",
        "auto_crud": true,
        "permission_required": true,
        "breadcrumb": "Alternate Blood Group Master",
        "check_permission": false
    },
    {
        "name": "menu.worklist",
        "icon": "fa fa-building-o",
        "data": {
            "nav_url": "bloodBank_format_m"
        },
        "children": [
            {
                "name": "menu.bloodBank_worklist",
                "resource": "bloodBank_format",
                "icon": "fa fa-file-text-o",
                "url": "bloodBank_format",
                "auto_crud": true,
                "breadcrumb": "Blood Request",
                "check_permission": false
            },
            {
                "name": "menu.bloodStock_worklist",
                "resource": "bloodStock_format",
                "icon": "fa fa-file-text-o",
                "url": "bloodStock_format",
                "auto_crud": true,
                "breadcrumb": "Blood Stock",
                "check_permission": false
            },
            {
                "name": "menu.bloodBank_worklist",
                "resource": "worklist_acknowledge_cross_match",
                "icon": "fa fa-file-text-o",
                "url": "worklist_acknowledge_cross_match",
                "auto_crud": true,
                "breadcrumb": "Blood Request",
                "check_permission": false
            },
            {
                "name": "menu.bloodBank_worklist",
                "resource": "organization_request_view",
                "icon": "fa fa-file-text-o",
                "url": "organization_request_view",
                "auto_crud": true,
                "breadcrumb": "Blood Request",
                "check_permission": false
            },
            {
                "name": "menu.bloodBank_worklist",
                "resource": "worklist_acknowledge_cross_match_new",
                "icon": "fa fa-file-text-o",
                "url": "worklist_acknowledge_cross_match_new",
                "auto_crud": true,
                "breadcrumb": "Blood Request",
                "check_permission": false
            },
            {
                "name": "menu.bloodBank_worklist",
                "resource": "organization_request_form",
                "icon": "fa fa-file-text-o",
                "url": "organization_request_form",
                "auto_crud": true,
                "breadcrumb": "Organization Request",
                "check_permission": false
            },
            {
                "name": "menu.bloodBank_worklist",
                "resource": "organization_request_acknowledge",
                "icon": "fa fa-file-text-o",
                "url": "organization_request_acknowledge",
                "auto_crud": true,
                "breadcrumb": "Organization Acknowledge",
                "check_permission": false
            },
            {
                "name": "menu.bloodBank_worklist",
                "resource": "view_acknowledge_cross_match_details",
                "icon": "fa fa-file-text-o",
                "url": "view_acknowledge_cross_match_details",
                "auto_crud": true,
                "breadcrumb": "Blood Request",
                "check_permission": false
            },
            {
                "name": "menu.bloodBank_worklist",
                "resource": "worklist_acknowledged_issue",
                "icon": "fa fa-file-text-o",
                "url": "worklist_acknowledged_issue",
                "auto_crud": true,
                "breadcrumb": "Acknowledged",
                "check_permission": false
            },
            {
                "name": "menu.bloodBank_worklist",
                "resource": "view_cross_match_details",
                "icon": "fa fa-file-text-o",
                "url": "view_cross_match_details",
                "auto_crud": true,
                "breadcrumb": "Acknowledged",
                "check_permission": false
            },
            {
                "name": "menu.bloodBank_worklist",
                "resource": "worklist_acknowledged_re_issue",
                "icon": "fa fa-file-text-o",
                "url": "worklist_acknowledged_re_issue",
                "auto_crud": true,
                "breadcrumb": "Returned Rquested",
                "check_permission": false
            },
            {
                "name": "menu.bloodBank_worklist",
                "resource": "worklist_op_issue",
                "icon": "fa fa-file-text-o",
                "url": "worklist_op_issue",
                "auto_crud": true,
                "breadcrumb": "Acknowledged",
                "check_permission": false
            },
            {
                "name": "menu.bloodStock_worklist",
                "resource": "blood_bank_stock",
                "icon": "fa fa-file-text-o",
                "url": "blood_bank_stock",
                "auto_crud": true,
                "breadcrumb": "Blood Stock",
                "check_permission": false
            },
            {
                "name": "menu.bloodBank_worklist",
                "resource": "worklist_view_reaction",
                "icon": "fa fa-file-text-o",
                "url": "worklist_view_reaction",
                "auto_crud": true,
                "breadcrumb": "Blood Request",
                "check_permission": false
            },
            {
                "name": "menu.bloodBank_worklist",
                "resource": "per_patient_track_bloodBank",
                "icon": "fa fa-file-text-o",
                "url": "per_patient_track_bloodBank",
                "auto_crud": true,
                "breadcrumb": "Blood Request",
                "check_permission": false
            },
            {
                "name": "menu.bloodBank_worklist",
                "resource": "raise_blood_bank_order",
                "icon": "fa fa-file-text-o",
                "url": "raise_blood_bank_order",
                "auto_crud": true,
                "breadcrumb": "Blood Raise Request",
                "check_permission": false
            },
            {
                "name": "menu.donor_patient_format",
                "resource": "donor_patient_format",
                "icon": "fa fa-file-text-o",
                "url": "donor_patient_format",
                "auto_crud": true,
                "permission_required": false,
                "breadcrumb": "Donor Registration Form",
                "check_permission": false
            },
            {
                "name": "menu.donor_registration_form",
                "resource": "donor_registration_form",
                "icon": "fa fa-file-text-o",
                "url": "donor_registration_form",
                "auto_crud": true,
                "permission_required": false,
                "breadcrumb": "Donor Registration Form",
                "check_permission": false
            },
            {
                "name": "menu.donor_registration_form_update",
                "resource": "donor_registration_form_update",
                "icon": "fa fa-file-text-o",
                "url": "donor_registration_form_update",
                "auto_crud": true,
                "permission_required": false,
                "breadcrumb": "Donor Registration Form",
                "check_permission": false
            },
            {
                "name": "menu.bloodStock_worklist",
                "resource": "blood_bank_expired",
                "icon": "fa fa-file-text-o",
                "url": "blood_bank_expired",
                "auto_crud": true,
                "breadcrumb": "Blood Stock",
                "check_permission": false
            },
            {
                name: 'menu.donor_patient_demographic_details_update',
                resource: 'donor_patient_demographic_details_update',
                icon: 'fa fa-user',
                url: 'donor_patient_demographic_details_update',
                auto_crud: true,
                showMenu: false,
                breadcrumb: 'Patient Update'
            },
            {
                name: 'menu.donor_template_view',
                resource: 'donor_template_view',
                icon: 'fa fa-user',
                url: 'donor_template_view',
                auto_crud: true,
                showMenu: false,
                breadcrumb: 'Donor Template View'
            },
            {
                "name": "menu.bloodBank_worklist",
                "resource": "worklist_acknowledge_cross_match_op",
                "icon": "fa fa-file-text-o",
                "url": "worklist_acknowledge_cross_match_op",
                "auto_crud": true,
                "breadcrumb": "Blood Request Acknowledge",
                "check_permission": false
            },
            {
                "name": "menu.bloodBank_worklist",
                "resource": "organization_request_form_op",
                "icon": "fa fa-file-text-o",
                "url": "organization_request_form_op",
                "auto_crud": true,
                "breadcrumb": "Blood Acknowledge",
                "check_permission": false
            },
            {
                "name": "menu.bloodBank_worklist",
                "resource": "organization_request_view_op",
                "icon": "fa fa-file-text-o",
                "url": "organization_request_view_op",
                "auto_crud": true,
                "breadcrumb": "Blood Request View",
                "check_permission": false
            },
            {
                "name": "menu.bloodBank_worklist",
                "resource": "organization_request_cancel",
                "icon": "fa fa-file-text-o",
                "url": "organization_request_cancel",
                "auto_crud": true,
                "breadcrumb": "Blood Request Cancel",
                "check_permission": false
            },
            {
                "name": "menu.bloodBank_worklist",
                "resource": "organization_request_status_view",
                "icon": "fa fa-file-text-o",
                "url": "organization_request_status_view",
                "auto_crud": true,
                "breadcrumb": "Blood Request View Status",
                "check_permission": false
            },
            {
                "name": "menu.bloodBank_worklist",
                "resource": "worklist_acknowledged_issue_op",
                "icon": "fa fa-file-text-o",
                "url": "worklist_acknowledged_issue_op",
                "auto_crud": true,
                "breadcrumb": "Organization Request Issue",
                "check_permission": false
            },
        ]
    },
    {
        "name": "menu.donor_patient",
        "icon": "fa fa-building-o",
        "data": {
            "nav_url": "donor_patient_tab_m"
        },
        children: [
            {
                "name": "menu.donor_patient",
                "resource": "donor_patient_tab",
                "icon": "fa fa-file-text-o",
                "url": "donor_patient_tab",
                "auto_crud": true,
                "breadcrumb": "Donor Registration",
                "check_permission": false
            },
            {
                "name": "menu.donor_patient",
                "resource": "donor_patient",
                "icon": "fa fa-file-text-o",
                "url": "donor_patient",
                "auto_crud": true,
                "breadcrumb": "Donor Registration",
                "check_permission": false
            },
            {
                "name": "menu.donor_request",
                "resource": "donor_request_tab",
                "icon": "fa fa-file-text-o",
                "url": "donor_request_tab",
                "auto_crud": true,
                "breadcrumb": "Donor Requested",
                "check_permission": false
            },
            {
                "name": "menu.donor_screening",
                "resource": "donor_screening",
                "icon": "fa fa-file-text-o",
                "url": "donor_screening",
                "auto_crud": true,
                "breadcrumb": "Donor Screening",
                "check_permission": false
            },
            {
                "name": "menu.accepted_donor",
                "resource": "accepted_donor",
                "icon": "fa fa-file-text-o",
                "url": "accepted_donor",
                "auto_crud": true,
                "breadcrumb": "Accepted Donor",
                "check_permission": false
            },
            {
                "name": "menu.rejected_donor",
                "resource": "rejected_donor",
                "icon": "fa fa-file-text-o",
                "url": "rejected_donor",
                "auto_crud": true,
                "breadcrumb": "Rejected Donor",
                "check_permission": false
            },
            {
                "name": "menu.donor_request_format",
                "resource": "donor_request_format",
                "icon": "fa fa-file-text-o",
                "url": "donor_request_format",
                "auto_crud": true,
                "permission_required": false,
                "breadcrumb": "Donor Registration Form",
                "check_permission": false
            },
            {
                "name": "menu.view_collected_blood",
                "resource": "view_collected_blood",
                "icon": "fa fa-file-text-o",
                "url": "view_collected_blood",
                "auto_crud": true,
                "permission_required": false,
                "breadcrumb": "View Collected Blood",
                "check_permission": false
            },
            {
                "name": "menu.aphresis_view_collected_blood",
                "resource": "aphresis_view_collected_blood",
                "icon": "fa fa-file-text-o",
                "url": "aphresis_view_collected_blood",
                "auto_crud": true,
                "permission_required": false,
                "breadcrumb": "View Collected Blood",
                "check_permission": false
            },
            {
                "name": "menu.donor_donation_history",
                "resource": "donor_donation_history",
                "icon": "fa fa-file-text-o",
                "url": "donor_donation_history",
                "auto_crud": true,
                "permission_required": false,
                "breadcrumb": "Donation History",
                "check_permission": false
            },
            {
                "name": "menu.tti_screening",
                "resource": "tti_screening",
                "icon": "fa fa-file-text-o",
                "url": "tti_screening",
                "auto_crud": true,
                "permission_required": false,
                "breadcrumb": "TTI Screening",
                "check_permission": false
            },
            {
                "name": "menu.donor_patient_view",
                "resource": "donor_patient_view",
                "icon": "fa fa-file-text-o",
                "url": "donor_patient_view",
                "auto_crud": true,
                "breadcrumb": "Accepted Donor",
                "check_permission": false
            },
            {
                "name": "menu.tti_screening",
                "resource": "tti_screening_result",
                "icon": "fa fa-file-text-o",
                "url": "tti_screening_result",
                "auto_crud": true,
                "permission_required": false,
                "breadcrumb": "TTI Screening",
                "check_permission": false
            },
            {
                "name": "menu.modify",
                "resource": "modify_blood_bank_stock",
                "icon": "fa fa-file-text-o",
                "url": "modify_blood_bank_stock",
                "auto_crud": true,
                "permission_required": false,
                "breadcrumb": "Modify Blood Bank Stock",
                "check_permission": false
            },
            {
                "name": "menu.tti_screening",
                "resource": "tti_screening_update",
                "icon": "fa fa-file-text-o",
                "url": "tti_screening_update",
                "auto_crud": true,
                "permission_required": false,
                "breadcrumb": "Update TTI Screening",
                "check_permission": false
            },
            {
                "name": "menu.donor_reaction",
                "resource": "donor_reaction",
                "icon": "fa fa-file-text-o",
                "url": "donor_reaction",
                "auto_crud": true,
                "permission_required": false,
                "breadcrumb": "TTI Screening",
                "check_permission": false
            },
            {
                "name": "menu.view_reaction_template",
                "resource": "view_reaction_template",
                "icon": "fa fa-file-text-o",
                "url": "view_reaction_template",
                "auto_crud": true,
                "permission_required": false,
                "breadcrumb": "TTI Screening",
                "check_permission": false
            },
        ]
    }
]
